import yup from '@/libs/yup.ts';

export default yup.object({
    file: yup.mixed().nullable()
});
